
export const Line = () => {
    return (
      <div className='line'></div>
    )
  }